import { BrowserRouter as Router, Switch, Route } from 'react-router-dom'
import Dashboard from './components/shared/Dashboard/Dashboard'
import Register from './components/admin/register/Register'
import Customers from './components/admin/customers/Customers'
import Statistics from './components/admin/Statistics/Statistics'

import Report from './components/admin/customers/Report/Report'
import AddCustomer from './components/admin/customers/addCustomer/AddCustomer'
import Profile from './components/users/profile/Profile'
import Sales from './components/users/sales/Sales'
import SignIn from './components/shared/authentication/SignIn'
import SignUp from './components/shared/authentication/SignUp'
import PrivateRoute from './components/shared/privateRoute/PrivateRoute'
import { AuthProvider } from './context/AuthContext'

import './App.css'
function App() {
	return (
		<div className="App">
			<Router>
				<AuthProvider>
					<Switch>
						<PrivateRoute exact path="/" component={Dashboard}/>
						<PrivateRoute path="/register" component={Register} />
						<PrivateRoute path="/customers" component={Customers} />
						<PrivateRoute path="/statistics" component={Statistics} />
						<PrivateRoute path="/add" component={AddCustomer} />
						<PrivateRoute path="/profile" component={Profile} />
						<PrivateRoute path="/sales" component={Sales} />
						<PrivateRoute path="/report" component={Report} />
						<Route path="/signup" component={SignUp} />
						<Route path="/signin" component={SignIn} />
					</Switch>
				</AuthProvider>
			</Router>
		</div>
	)
}

export default App
/*
<Router>
				<Navigation />
				<div className="AppContents">
					<AuthProvider>
						<Switch>
							<PrivateRoute
								exact
								path="/"
								register={Register}
								profile={Profile}
							/>
							<Route path="/register" component={Register} />
							<Route path="/customers" component={Customers} />
							<Route path="/add" component={AddCustomer} />
							<Route path="/profile" component={Profile} />
							<Route path="/sales" component={Sales} />
							<Route path="/signup" component={SignUp}/>
							<Route path="/signin" component={SignIn}/>
						</Switch>
					</AuthProvider>
				</div>
			</Router>
*/
